import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Scroll from 'react-scroll';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';
import LeadController from '../../controller/LeadController';
import CustomerAddEditInfo from './CustomerAddEditInfo';
import CustomerAddEditContact from './CustomerAddEditContact';
import CustomerAddEditCustom from './CustomerAddEditCustom';

import CustomerAPI from '../../api/CustomerAPI';
import ApiUiController from '../../controller/ApiUiController';
import ValidationController from '../../controller/ValidationController';
import Util from '../../util/Util';

class CustomerUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.customerId);
    this.model = reactLocalStorage.getObject(Const.Model).customer;
    this.customer = LeadController.addModel(this.model.fields);
    this.customer.id = 0;
    this.customer.lead = 0;
    this.state = { inApiCall: this.id !== 0, inValid: {}  };

    this.base = this.props.match.path
    this.base = this.base.substring(0, this.base.indexOf('/add-edit'));
  }

  componentDidMount() {
    if(this.id !== 0) {
      CustomerAPI.get(this.id, this.onReceived, this.failure);
    }
  }

  failure = res => {
    Scroll.scroller.scrollTo(Object.keys(res)[0], { duration: 1500, smooth: true });
    const message = Util.failure(res);
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false, inValid: { ...res } });
  }

  onSave = () => {
    const inValid = ValidationController.validate(this.model.fields, this.customer);
    if(inValid === null) {
      this.setState({ ...this.state, inApiCall: true });
      CustomerAPI.save(this.customer, this.onUpdateReceived, this.failure);
    } else {
      const message = Util.failure(inValid);
      Util.showError(message);
      Scroll.scroller.scrollTo(Object.keys(inValid)[0], { duration: 1500, smooth: true });
      this.setState({ ...this.state, inValid: { ...inValid } });
    }
  }
  onReceived = customer => { this.customer = customer; this.setState({ inApiCall: false }); }
  onUpdateReceived = res => this.props.navigate(`${this.base}/preview/${res.id}`);

  onValueChange = (field, value) => {
    this.customer[field] = value;
    this.setState({ ...this.state, inValid: {} });
  }
  
  render() {
    return (
      <div className="sectionform">
        <div className="container form-cont">
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              
              <CustomerAddEditInfo model={this.model} lead={this.customer}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />

              <CustomerAddEditContact model={this.model} lead={this.customer}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />
              
              <CustomerAddEditCustom model={this.model} lead={this.customer}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />
              
              <div className="col-md-12 text-center btnsend">
                <Button className="buttons btn-success" onClick={this.onSave}>
                  { this.id === 0 ? 'Save' : 'Update' } Customer
                </Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(CustomerUpdate);